<template>
  <div>
    <el-row
      :gutter="15"
      justify="space-between"
      style="margin-bottom: 10px"
      v-if="companyCode === 'TB'"
    >
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="SEAHORSE"
          icon="mdi mdi-file-document-edit success-text"
          :total="seahorseCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ seahorseContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ seahorseEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="MAGYLOTTERY"
          icon="mdi mdi-file-document-edit success-text"
          :total="magylotteryCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ magylotteryContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ magylotteryEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <!-- el-icon-open -->
        <card-total
          text="NCF MOVIL"
          icon="mdi mdi-file-document-edit success-text"
          :total="ncfmovilCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ ncfmovilContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ ncfmovilEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="MAGYPAGO"
          icon="mdi mdi-file-document-edit  success-text"
          :total="magypagoCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ magypagoContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ magypagoEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="MAGYTRACK"
          icon="mdi mdi-file-document-edit success-text"
          :total="magytrackCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ magytrackContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ magytrackEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
    </el-row>
    <el-row
      :gutter="15"
      justify="space-between"
      style="margin-bottom: 10px"
      v-if="companyCode === 'MTR'"
    >
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="NAVISION"
          icon="mdi mdi-file-document-edit success-text"
          :total="magytrackCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Contratos :
              {{ magytrackContractCount }}</span
            >
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ magytrackEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="NAVYXY"
          icon="mdi mdi-file-document-edit success-text"
          :total="navixyCount"
          :loading.sync="loading"
        >
          <template #moreIcons>
            <span style="font-size: 95%" class="info-text self-flex-start">
              <i class="el-icon-view" /> Equipos :
              {{ navixyEquimentCount }}</span
            >
          </template>
        </card-total>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <CardNavixySinContractVue />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <CardStatDiffEquipmentNavisionVsNavixyVue />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";
import CardNavixySinContractVue from "./requests/CardNavixySinContract.vue";
import CardStatDiffEquipmentNavisionVsNavixyVue from "./requests/CardStatDiffEquipmentNavisionVsNavixy.vue";

export default {
  name: "cardcountRequest",
  data: function () {
    return {
      loading: false,
      drawer: false,
      drawerNavNav: false
    };
  },
  props: {
    seahorseCount: {
      type: [Number, String],
      default: 0
    },
    seahorseContractCount: {
      type: [Number, String],
      default: 0
    },
    seahorseEquimentCount: {
      type: [Number, String],
      default: 0
    },
    magylotteryCount: {
      type: [Number, String],
      default: 0
    },
    magylotteryContractCount: {
      type: [Number, String],
      default: 0
    },
    magylotteryEquimentCount: {
      type: [Number, String],
      default: 0
    },
    ncfmovilCount: {
      type: [Number, String],
      default: 0
    },
    ncfmovilContractCount: {
      type: [Number, String],
      default: 0
    },
    ncfmovilEquimentCount: {
      type: [Number, String],
      default: 0
    },
    magypagoCount: {
      type: [Number, String],
      default: 0
    },
    magypagoContractCount: {
      type: [Number, String],
      default: 0
    },
    magypagoEquimentCount: {
      type: [Number, String],
      default: 0
    },
    magytrackCount: {
      type: [Number, String],
      default: 0
    },
    magytrackContractCount: {
      type: [Number, String],
      default: 0
    },
    magytrackEquimentCount: {
      type: [Number, String],
      default: 0
    },
    navixyCount: {
      type: [Number, String],
      default: 0
    },
    navixyEquimentCount: {
      type: [Number, String],
      default: 0
    },
    navixyNavisionCount: {
      type: [Number, String],
      default: 0
    },
    navixyNavisionEquimentCount: {
      type: [Number, String],
      default: 0
    },
    navixyWithoutUserCount: {
      type: [Number, String],
      default: 0
    },
    navixyWithoutEquimentCount: {
      type: [Number, String],
      default: 0
    },
    contractTooltipText: {
      type: String,
      default: " Contratos:",
      required: false
    },
    companyCode: {
      type: String,
      default: "TB"
    }
  },
  components: {
    CardTotal,
    CardNavixySinContractVue,
    CardStatDiffEquipmentNavisionVsNavixyVue
  },
  methods: {
    getTotalUsers() {}
  }
};
</script>
<style>
.main-section {
  width: 100%;
  text-align: center;
  padding: 0px 0px;
  margin-bottom: 1%;
}
.dashbord {
  padding-left: 8px;

  display: inline-block;
  background-color: white;
  color: #fff;
  margin-top: 10px;
  width: 250px;
}
.icon-section i {
  font-size: 30px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-bottom: 10px;
  background-color: #34495e;
}
.icon-section p {
  margin: 0px;
  font-size: 20px;
  padding-bottom: 10px;
}
.detail-section {
  background-color: #2f4254;
  padding: 5px 0px;
}
.dashbord .detail-section:hover {
  background-color: #5a5a5a;
  cursor: pointer;
}
.detail-section a {
  color: #fff;
  text-decoration: none;
}
.dashbord-white .icon-section,
.dashbord-white .icon-section i {
  background-color: #34495e;
}
.dashbord-white .detail-section {
  background-color: #34495e;
}
.dashbord-green .icon-section,
.dashbord-green .icon-section i {
  background-color: #16a085;
}
.dashbord-green .detail-section {
  background-color: #149077;
}
.dashbord-orange .icon-section,
.dashbord-orange .icon-section i {
  background-color: #f39c12;
}
.dashbord-orange .detail-section {
  background-color: #da8c10;
}
.dashbord-blue .icon-section,
.dashbord-blue .icon-section i {
  background-color: #2980b9;
}
.dashbord-blue .detail-section {
  background-color: #2573a6;
}
.dashbord-red .icon-section,
.dashbord-red .icon-section i {
  background-color: #e74c3c;
}
.dashbord-red .detail-section {
  background-color: #cf4436;
}
.dashbord-skyblue .icon-section,
.dashbord-skyblue .icon-section i {
  background-color: #b679cf;
}
.dashbord-skyblue .detail-section {
  background-color: #b061d0;
}
</style>
